import React, { useState, useContext } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { LOCALES } from '../../i18n';
import { AppContext } from '../context';
import ReponseForm from "../forms/ReponseForm"
import QuestionForm from "../forms/QuestionForm"
import translate from '../../i18n/translate';
import ConfirmModal from '../forms/ConfirmModal';
import NewQuestionForm from '../forms/newQuestionForm';
import { SessionContext } from '../../services/SessionProvider';
import { KeycloackContext } from '../../services/keycloakProvider';
import { getReponseById, updateReponse, deleteReponse, createQuestion } from '../../services/requestHandler';


const default_color = "#8EBF55";
const green = "#307B5B"; // TYPE_2

export default function CarteNewQuestion({ id="", reponse_id="", reponse_type = "", text_en, text, needReloadComponent, reloadComponent }){
  const {state} = useContext(AppContext);
  const { getCurrentParentQuestion, getNewNoQuestion } = useContext(SessionContext)
  const { isAdminRole } = useContext(KeycloackContext)
  const [createFormOpen, setCreateFormOpen] = useState(false);

  const [reponseInfos, setReponseInfos] = useState({
    id: "",
    reponse_id: "",
    reponse_type: "",
    contenu: "",
    contenu_en: "",
  })
  const [cardColor] = useState(default_color)
  const [hoverColor] = useState(green)
  const [editFormOpen, setEditFormOpen] = useState(false);
  const [createQuestionFormOpen, setCreateQuestionFormOpen] = useState(false);
  const [reponseText, setReponseText] = useState("");
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  React.useEffect(() => {
    setReponseInfos({
      id: id,
      reponse_id: reponse_id,
      reponse_type: reponse_type,
      contenu: text,
      contenu_en: text_en,
    })

    if(state.locale === LOCALES.FRENCH) {
      setReponseText(text)
    }
    else if(state.locale === LOCALES.ENGLISH) {
      setReponseText(text_en)
    }
    // eslint-disable-next-line
  },[reponse_type, text, text_en, state.locale])
  
  async function handleEditReponseClick(newReponseInfos){
    let tempReponse = await getReponseById(newReponseInfos.reponse_id)
    tempReponse.contenu = newReponseInfos.contenu
    tempReponse.contenu_en = newReponseInfos.contenu_en

    await updateReponse(updateReponse);
    needReloadComponent(!reloadComponent)
  };

  async function handleCreateQuestionClick(newQuestionInfos){
    const newQuestionBody = {
        contenu: newQuestionInfos.contenu,
        contenu_en: newQuestionInfos.contenu_en,
        noQuestion: getNewNoQuestion(),
    }
    const newQuestion = await createQuestion(newQuestionBody);

    let reponseTemp = await getReponseById(newQuestionInfos.parent_id)
    reponseTemp.question_sv_id = newQuestion.id;
    await updateReponse(reponseTemp)
    needReloadComponent(!reloadComponent)
  };

  async function handleDeleteClick(){
    const parent_temp = getCurrentParentQuestion();
    var body = {
      reponse_enfant_id: reponse_id,
      reponse_parent_id: parent_temp === '0' ? null : parent_temp,
    };

    await deleteReponse(body)
  };
  

  return (
    <div style={{ marginTop: "20px"}}>
        <Card 
          onClick={() => setCreateFormOpen(true)}
          sx={{
          backgroundColor: cardColor,
          minWidth: "90%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          ':hover': {
            backgroundColor: hoverColor, 
          }
          }} style={{display: "flex", justifyContent: "center" }}>
          <CardContent style={{ width: "100%"}}>
            <div style={{display: "flex"}}>
              <div style={{alignSelf: "center", marginRight: "auto"}}>
                <Typography variant="body2" style={{fontWeight: "bold", fontSize: "1rem"}}> {reponseText} </Typography>
              </div>
              <div style={{justifyContent: "right", display: "grid"}}>
                <div>
                  {isAdminRole && <IconButton onClick={(e) => {
                    e.preventDefault()
                    setEditFormOpen(true)
                    }} aria-label="Edit"> <EditIcon sx={{ color: "black" }} /> </IconButton>}
                  {/* {isAdminRole && <IconButton onClick={(e) => {
                    e.preventDefault()
                    setConfirmDeleteOpen(true)
                    }} aria-label="DeleteForever"> <DeleteForeverIcon sx={{ color: "black" }}/> </IconButton>} */}
                </div>
              </div>
              <div style={{alignSelf: "center"}}>
                <Chip label={id} sx={{ backgroundColor: "white", fontWeight: "bold"}} />
              </div>
            </div>
          </CardContent>
        </Card>
        {createFormOpen && <NewQuestionForm
            reponse_id={reponse_id}
            open={createFormOpen}
            setOpen={setCreateFormOpen}
            onConfirm={handleCreateQuestionClick}
            title={"Selectionner ou tapez votre question"}
            description={"Question Selector"}
        />}
        {editFormOpen && <ReponseForm
            reponse={reponseInfos}
            open={editFormOpen}
            setOpen={setEditFormOpen}
            onConfirm={handleEditReponseClick}
            title={"Edit reponse"}
            description={"Veuillez remplir les cases suivantes pour editer la reponse"}
        />}
        {createQuestionFormOpen && <QuestionForm
            open={createQuestionFormOpen}
            setOpen={setCreateQuestionFormOpen}
            onConfirm={handleCreateQuestionClick}
            title={"Vous devez creer la question"}
            description={"Veuillez remplir les cases suivantes pour creer la question"}
        />}
        {confirmDeleteOpen && <ConfirmModal
                content={translate("questionnaire.supprimer_element")}
                open={confirmDeleteOpen}
                setOpen={setConfirmDeleteOpen}
                onConfirm={handleDeleteClick}
        />}
    </div>
  );
}